import type { FeatureKeys } from '@owl-frontend/api-client';
import type { User } from '@owl-frontend/api-client/interface';
import { AsyncActionState, setupSlice } from '@owl-frontend/redux';

export interface SessionState {
  current?: User;
  features: {
    [k in FeatureKeys]?: true;
  };
  actions: {
    current: AsyncActionState;
    fetchFeatures: AsyncActionState;
    logEvent: AsyncActionState<void>;
    logout: AsyncActionState<void>;
  };
}

const initialState: SessionState = {
  features: {},
  actions: {
    current: { status: 'uninitialized' },
    fetchFeatures: { status: 'uninitialized' },
    logEvent: { status: 'uninitialized' },
    logout: { status: 'uninitialized' },
  },
};

const sessionSlice = setupSlice('session', initialState);
export default sessionSlice;
